import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';
import useModulePermissions from '../../hooks/useModulePermissions';

const AUTH_TYPES = {
  PUBLIC: 'public',
  INTERNAL: 'internal',
  PASSENGER: 'passenger',
  PARTNER: 'partner'
};

const isInternalLogged = () => {
  return !!sessionStorage.getItem('codUser');
};

const isPassengerLogged = () => {
  return !!(
    sessionStorage.getItem('codOS') ||
    sessionStorage.getItem('localizador')
  );
};

const isPartnerLogged = () => {
  return !!(
    sessionStorage.getItem('codPartner') ||
    sessionStorage.getItem('partnerUser') ||
    sessionStorage.getItem('idFornecedor')
  );
};

const isAuthenticatedByType = (authType) => {
  switch (authType) {
    case AUTH_TYPES.PUBLIC:
      return true;

    case AUTH_TYPES.INTERNAL:
      return isInternalLogged();

    case AUTH_TYPES.PASSENGER:
      return isPassengerLogged();

    case AUTH_TYPES.PARTNER:
      return isPartnerLogged();

    default:
      return false;
  }
};

const getRedirectPathByType = (authType) => {
  switch (authType) {
    case AUTH_TYPES.PASSENGER:
      return '/appcli';

    case AUTH_TYPES.PARTNER:
      return '/partner';

    case AUTH_TYPES.INTERNAL:
    default:
      return '/login';
  }
};

const ProtectedRouteWithLayout = ({
  layout: Layout,
  component: Component,
  moduleCode,
  requiredPerm,
  isPublic = false,
  authType,
  redirectTo,
  ...rest
}) => {
  const resolvedAuthType = isPublic
    ? AUTH_TYPES.PUBLIC
    : (authType || AUTH_TYPES.INTERNAL);

  const isLogged = isAuthenticatedByType(resolvedAuthType);
  const currentModule = Number(sessionStorage.getItem('modulo'));

  const shouldCheckPermissions =
    resolvedAuthType === AUTH_TYPES.INTERNAL && !isPublic;

  const { hasPerm, loading, permissions } = useModulePermissions(
    shouldCheckPermissions ? moduleCode : null
  );

  /*console.log('--- ProtectedRouteWithLayout ---');
  console.log('path:', rest.path);
  console.log('moduleCode:', moduleCode);
  console.log('currentModule:', currentModule);
  console.log('requiredPerm:', requiredPerm);
  console.log('resolvedAuthType:', resolvedAuthType);
  console.log('isLogged:', isLogged);
  console.log('loading:', loading);
  console.log('permissions:', permissions);
  console.log('authType:', authType); */


  if (shouldCheckPermissions && requiredPerm) {
    console.log('hasPerm(requiredPerm):', hasPerm(requiredPerm));
  }

  const defaultRedirectTo = redirectTo || getRedirectPathByType(resolvedAuthType);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (resolvedAuthType === AUTH_TYPES.PUBLIC) {
          return (
            <Layout>
              <Component {...props} />
            </Layout>
          );
        }

        if (!isLogged) {
          return <Redirect to={defaultRedirectTo} />;
        }

        // Só módulos internos carregam permissões
        if (shouldCheckPermissions && loading) {
          return (
            <Layout>
              <div style={{ padding: 24 }}>Carregando permissões...</div>
            </Layout>
          );
        }

        // Validação de módulo somente para acesso interno
        if (
          shouldCheckPermissions &&
          moduleCode &&
          currentModule &&
          currentModule !== moduleCode
        ) {
          return <Redirect to="/not-found" />;
        }

        // Permissão somente para acesso interno
        if (
          shouldCheckPermissions &&
          requiredPerm &&
          moduleCode &&
          !hasPerm(requiredPerm)
        ) {
          console.log('***** sem permissão para', requiredPerm);
          return <Redirect to="/sem-permissao" />;
        }

        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      }}
    />
  );
};

ProtectedRouteWithLayout.propTypes = {
  layout: PropTypes.elementType.isRequired,
  component: PropTypes.elementType.isRequired,
  moduleCode: PropTypes.number,
  requiredPerm: PropTypes.number,
  isPublic: PropTypes.bool,
  authType: PropTypes.oneOf(['public', 'internal', 'passenger', 'partner']),
  redirectTo: PropTypes.string
};

ProtectedRouteWithLayout.defaultProps = {
  isPublic: false,
  authType: 'internal',
  redirectTo: undefined,
  moduleCode: undefined,
  requiredPerm: 0
};

export default ProtectedRouteWithLayout;